import { Injector, computed, inject, signal } from "@angular/core";
import { CommonForm, CommonNumberField, CommonNumberFieldConfig, CommonTextField, CommonTextFieldConfig, CommonUrlField, CommonUrlFieldConfig } from "@eforall/common";
import { AccVentureUpdateValues } from "@interfaces";
import { AccVentureDialogDataService } from "../acc-venture-dialog-data.service";

export class DetailsPartForm {

	private readonly dialogDataService = inject(AccVentureDialogDataService);
	public readonly form = new CommonForm<AccVentureUpdateValues>(inject(Injector));

	readonly name = computed<CommonTextField>(() => ({
		config: signal<CommonTextFieldConfig>({
			label: 'Venture Name',
			isRequired: true,
			min: 1,
			max: 100,
			fixCase: 'sentence-case',
			multiLine: false,
		}),
		formFieldName: 'ventureName',
		form: this.form,
		actualValue: computed(() => this.dialogDataService.dialogData()?.ventureName ?? ''),
		pendingValue: signal<string | null>(null),
		saving: signal(false),
		error: signal(''),
	}));

	readonly workbookDriveURL = computed<CommonUrlField>(() => ({
		config: signal<CommonUrlFieldConfig>({
			label: 'Workbook Drive URL',
			isRequired: false,
			isEnabled: computed(() => this.dialogDataService.canEdit())
		}),
		formFieldName: 'workbookDriveURL',
		form: this.form,
		actualValue: computed(() => this.dialogDataService.dialogData()?.workbookDriveURL ?? ''),
		pendingValue: signal<string | null>(null),
		saving: signal(false),
		error: signal(''),
	}));



	readonly websiteURL = computed<CommonUrlField>(() => ({
		config: signal<CommonUrlFieldConfig>({
			label: 'Website URL',
			isRequired: false,
			isEnabled: computed(() => this.dialogDataService.canEdit())
		}),
		formFieldName: 'websiteURL',
		form: this.form,
		actualValue: computed(() => this.dialogDataService.dialogData()?.websiteURL ?? ''),
		pendingValue: signal<string | null>(null),
		saving: signal(false),
		error: signal(''),
	}));


	readonly workbookScore = computed<CommonNumberField>(() => ({
		config: signal<CommonNumberFieldConfig>({
			label: 'Workbook Score',
			isRequired: false,
			type: 'percentage',
		}),
		formFieldName: 'workbookScore',
		form: this.form,
		actualValue: computed(() => this.dialogDataService.dialogData()?.workbookScore),
		pendingValue: signal<number | null>(null),
		saving: signal(false),
		error: signal(''),
	}));

}